import React, { memo } from 'react'
import PropTypes from 'prop-types'

function LandingBox({ children, className }) {
  return <div className={className}>{children}</div>
}

LandingBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}
LandingBox.defaultProps = {
  className: ''
}

export default memo(LandingBox)
